import { render, staticRenderFns } from "./DashboardRedirect.vue?vue&type=template&id=725a2de7&"
import script from "./DashboardRedirect.vue?vue&type=script&lang=js&"
export * from "./DashboardRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports